var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-products items-list clp-list"},_vm._l((_vm.values),function(item,index){return _c('Products',{key:`${index}::${item.productId}`,staticClass:"clp-list__item items-list__item",attrs:{"type":'clp',"item":item,"source":"GIFT_FINDER"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }